export default __webpack_public_path__ + "static/media/home-upload.10d7a44b.svg";